import AssignmentForm from "../../admin/assignments/AssignmentForm";
import { Alert, Empty, Spin } from "antd"
import { useDispatch } from "react-redux"
import AssignmentsTable from "../../admin/assignments/AssignmentsTable";
import { useGetAssignmentsQuery } from "../../../features/assignments/assignmentsApi";
import { editAssignment, toggleModal } from "../../../features/assignments/assignmentsSlice";

export default function Assignments() {
  const dispatch = useDispatch()

  const { data: assignments, isLoading, isError, error } = useGetAssignmentsQuery()

  // decide what to render 
  let render = null;
  if (isLoading) {
    render = <Spin />
  } else if (isError && error) {
    render = <Alert message="Error" description={typeof error?.data == 'string' ? error?.data : 'Something went wrong'}
      type="error"
      showIcon
    />
  } else if (!assignments?.length) {
    render = <Empty description="No Data Found" />
  } else {
    render = <AssignmentsTable assignments={assignments} />
  }

  const openModalHandler = () => {
    dispatch(editAssignment({}))
    dispatch(toggleModal(true))
  }
  return (
    <>
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <div className="px-3 py-20 bg-opacity-10">
            <div className="w-full flex">
              <button className="btn cursor-pointer ml-auto" onClick={openModalHandler}>Add Assignment</button>
            </div>
            <div className="overflow-x-auto mt-4">
              {render}
            </div>
          </div>
        </div>
      </section>

      <AssignmentForm />
    </>
  )
}